import { Component, HostListener } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OeAppService } from '../../shared/oe-app.service';
import { Gender } from '../gender';
import {
  buttonHover,
  growBounce,
  lastUp,
  placementExamAnimationsWrapper,
  revealUp,
  titleReveal,
} from './activation-placement-exam-modal-animations';

@Component({
  selector: 'lp2-activation-placement-exam-modal',
  templateUrl: './activation-placement-exam-modal.component.html',
  styleUrls: ['./activation-placement-exam-modal.component.scss'],
  animations: [placementExamAnimationsWrapper, titleReveal, revealUp, growBounce, lastUp, buttonHover],
})
export class ActivationPlacementExamModalComponent {
  Gender = Gender;
  gender = Gender.MASCULINE.toString();
  userName = '';
  animateHover = 1;

  constructor(private ngbActiveModal: NgbActiveModal, oeAppService: OeAppService) {
    const person = oeAppService.getData('person');
    this.gender = person.gender;
    this.userName = person.firstName;
  }

  close() {
    this.ngbActiveModal.close();
  }

  @HostListener('mouseenter')
  onmouseenter() {
    this.animateHover++;
  }

  @HostListener('mouseleave')
  onmouseleave() {
    this.animateHover--;
  }
}



// WEBPACK FOOTER //
// ./ts/app/overlay/activation-placement-exam-modal/activation-placement-exam-modal.component.ts